import { Box, keyframes, SvgIcon, SvgIconProps } from '@mui/material';
import { FC } from 'react';

type ProgressProps = {
  size?: number;
  text?: string;
  color?: string;
  absolute?: boolean;
  margin?: string;
};

const NewFocalIconSvG: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox={props.viewBox || '0 0 36 36'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8815 6.0625C16.1536 6.0625 15.5252 6.57348 15.3753 7.28729L14.3847 12.0037H8.42731C7.6994 12.0037 7.07101 12.5147 6.92108 13.2285L4.1343 26.4966C3.32883 30.3315 6.2486 33.9375 10.1592 33.9375H23.1185C23.8464 33.9375 24.4748 33.4265 24.6247 32.7127L25.6153 27.9963H31.5727C32.3006 27.9963 32.929 27.4853 33.0789 26.7715L35.8657 13.5034C36.6712 9.66847 33.7514 6.0625 29.8408 6.0625H16.8815ZM25.6153 27.9963L28.4534 14.484C28.7219 13.2057 27.7486 12.0037 26.4451 12.0037H14.3847L11.5466 25.516C11.2781 26.7943 12.2514 27.9963 13.5549 27.9963H25.6153Z"
        fill={props.fill || 'white'}
      />
      <path
        d="M25.2892 20.0162C25.2892 22.9446 22.9203 25.3186 19.9981 25.3186C17.0759 25.3186 14.707 22.9446 14.707 20.0162C14.707 17.0878 17.0759 14.7139 19.9981 14.7139C22.9203 14.7139 25.2892 17.0878 25.2892 20.0162Z"
        fill={props.fill || 'white'}
      />
    </SvgIcon>
  );
};

const pulse = keyframes`
 0% {
          opacity: 0.2;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0.2;
        }
`;

export const Progress: FC<ProgressProps> = ({
  size = 50,
  text,
  color = '#606060',
  absolute = true,
  margin,
}) => (
  <Box
    sx={{
      position: absolute ? 'absolute' : 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: margin ?? 'auto',
      pointerEvents: 'none',
    }}
    role="progressbar"
  >
    <NewFocalIconSvG
      viewBox="0 0 36 36"
      fill={color}
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        position: 'relative',
        animation: `${pulse} 3000ms infinite`,
        transformOrigin: 'center',

        fill: color,

        ...(!text && { marginRight: '0 !important' }),
      }}
      data-testid="loading-spinner"
    />
    {text && (
      <Box
        sx={{
          fontSize: '12px',
          color,
          marginTop: '24px',
          whiteSpace: 'nowrap',
          fontFamily: 'Roboto',
        }}
      >
        {text}
      </Box>
    )}
  </Box>
);
